import { LABS_EYEBROW, cover, pdf } from '@/content/reportBuilder'
import { TRENDS_INTRO, TRENDS_SLUG } from '@/content/topTrends2026'
import type { Report } from '@/content/reportBuilder'

export const report: Report = {
  // The twentieth report with a designed page of its own, and the first that is
  // neither a cut of the maturity study nor a Future 2030 outlook — asked for on
  // 2026-08-28 in the same words as the ten outlooks before it (*"referans alarak
  // ilgili sayfayı birebir tıpa tıp aynısını tasarla"*) with a five-part full-page
  // capture of the live page and the three report mockups it carries. See
  // `content/topTrends2026.ts` and `pages/TopTrends2026.tsx`.
  slug: TRENDS_SLUG,
  title: 'Top 10 Trends 2026',
  eyebrow: LABS_EYEBROW,
  headline: 'Top 10 Trends 2026',
  shortName: 'Top 10 Trends 2026 report',
  partOfStudy: false,
  cover: cover('top-10-trends-2026-cover', 'Top 10 Trends 2026'),
  // The hero's one paragraph — same as the outlook entries, and for the same reason:
  // this page draws its hero from `TRENDS_INTRO` directly, so `body` feeds exactly one
  // thing, the meta description `prerender.tsx` takes from `body[0]`.
  body: [TRENDS_INTRO.body[0]],
  download: pdf('37a25e87-6256-4522-813a-ddbf4e2d2e83-digitopia_top-10-trends-2026.pdf'),
  layout: 'top-10-trends',
  // Its own words, its cover, its file and the three mockups its bands draw, so
  // `stillToCome` has nothing left to say about it. What is still open is
  // section-by-section on its page, and `topTrends2026Checks()` carries that into
  // the manifest.
  check: undefined,
}

/** Its place in the index grid — the order the imported page listed them. */
export const order = 20
